import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material"

// TODO: extend with description, mnemonics etc.
export type ReplaceField = "label" | "unit suffix"

const FIELDS: { label: string; field: ReplaceField }[] = [
  { label: "Label", field: "label" },
  { label: "Unit suffix", field: "unit suffix" },
]

type FieldRadioGroupProps = {
  onChange: (field: ReplaceField) => void
  selectedField: ReplaceField
}

const FieldRadioGroup = (props: FieldRadioGroupProps) => {
  return (
    <FormControl>
      <FormLabel>Field: </FormLabel>
      <RadioGroup
        aria-labelledby="radio-buttons-group-label-lower"
        defaultValue="female"
        name="radio-buttons-group"
        value={props.selectedField}
        onChange={(event) => props.onChange(event.target.value as ReplaceField)}
        sx={{ ml: 2 }}
        row
      >
        {FIELDS.map((field) => (
          <FormControlLabel
            key={field.field}
            value={field.field}
            control={<Radio size="small" />}
            label={field.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  )
}

export default FieldRadioGroup
